export default "__VITE_ASSET__DE1Idb28__"